import type { AgreementsActivityResult } from '../../activity-handler/agreements-activity.types';
import { fetchGetDwtPayloadsActivity } from '../api/fetch-get-dwt-payloads-activity';
import type { DwtPayloadsPayload } from '../models/dwt-payloads.model';

/** Injected collaborators for {@link fetchDwtPayloadsReport} (composition root / tests). */
export interface DwtPayloadsReportFetchDeps {
    fetchGetDwtPayloads(
        accessToken: string,
        payload: DwtPayloadsPayload
    ): Promise<AgreementsActivityResult>;
}

export const defaultDwtPayloadsReportFetchDeps: DwtPayloadsReportFetchDeps = {
    fetchGetDwtPayloads: fetchGetDwtPayloadsActivity,
};
